import type { components } from '@/api/schema'

const levels: Record<string, string> = {
  no_evidence: 'No visible evidence',
  weak: 'Weak visible evidence',
  possible: 'Some visible evidence; uncertain',
  strong: 'Strong visible evidence',
  very_strong: 'Very strong visible evidence',
}

export function Assessments({
  result,
}: {
  result: components['schemas']['ClassificationResult'] | null
}) {
  if (!result || result.error) return null
  const available = (
    [
      ['spam_score', 'Spam'],
      ['phishing_score', 'Phishing'],
    ] as const
  ).filter(([key]) => result.answers?.[key])
  if (!available.length) return null
  return (
    <section aria-label="Email assessments" className="space-y-3 border-t pt-4">
      <h3 className="text-sm font-semibold">Email assessments</h3>
      <dl className="space-y-3 text-sm">
        {available.map(([key, label]) => {
          const answer = result.answers?.[key]
          const distribution =
            answer?.kind === 'score' ? answer.probabilities : null
          const ranked = Object.entries(distribution ?? {})
            .filter(
              ([code, probability]) =>
                code in levels && Number.isFinite(probability),
            )
            .sort((a, b) => b[1] - a[1])
          const level =
            answer?.value == null || !ranked.length
              ? 'Unknown'
              : ranked[0]?.[1] === ranked[1]?.[1]
                ? 'Uncertain'
                : levels[ranked[0]![0]]
          return (
            <div key={key} className="flex flex-wrap justify-between gap-2">
              <dt className="font-medium">{label}</dt>
              <dd className="text-muted-foreground">{level}</dd>
            </div>
          )
        })}
      </dl>
    </section>
  )
}
